import type { TImportDataDictionary } from "components/ImportData/type";
import { updateImportSalesRows } from "store/dataImportSlice";

import type { CorrectionPanelConfig } from "../index";
import { SALES_COLUMNS_CONFIG } from "./sales";

export const SALES_CORRECTION_CONFIG: CorrectionPanelConfig = {
    columns: SALES_COLUMNS_CONFIG,
    contentType: "sales",
    updateAction: updateImportSalesRows,
};

// Content type mapping function
export const getCorrectionPanelConfig = (contentType: TImportDataDictionary): CorrectionPanelConfig => {
    switch (contentType) {
        case "sales":
            return SALES_CORRECTION_CONFIG;
        default:
            console.error(`No configuration found for content type: ${contentType}`);
            throw new Error(`Unsupported content type: ${contentType}`);
    }
};
